import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchCompanies } from '@/api/v4/organization.api';
import { QueryKey } from '@/config/query-client';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import {
  appliedCompaniesFiltersState,
  companiesSortState,
} from '../companies.state';
import { prepareCompanyApiFilters } from '../filters/company-filters-helpers';
import { useAtomValue } from 'jotai';

export const useCompanies = () => {
  const { hasRequiredPermission } = useUserPermissions();

  const appliedFilters = useAtomValue(appliedCompaniesFiltersState);

  const sortState = useAtomValue(companiesSortState);

  const filters = prepareCompanyApiFilters(appliedFilters);

  return useInfiniteQuery({
    queryKey: [QueryKey.Companies, sortState, filters],
    queryFn: ({ pageParam = 1 }) => {
      const params = {
        sort: sortState?.sort,
        direction: sortState?.direction,
        page: pageParam,
        items: 20,
        ...filters,
      };
      return fetchCompanies(params);
    },
    initialPageParam: 1,
    enabled: hasRequiredPermission(PERMISSION.VIEW_ORGANIZATION_LIST),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.length ? allPages.length + 1 : undefined;
      return nextPage;
    },
    staleTime: 1000 * 60 * 5,
  });
};
